import React from 'react';
import { AppBar, Toolbar, Typography, Badge, IconButton, Box } from '@mui/material';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';

function Header({ basketCount, onBasketClick }) {
  return (
    <AppBar position="sticky" className="glass-dark" elevation={0}>
      <Toolbar>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <img 
            src="/withoutbg.png" 
            alt="8qn-download" 
            style={{ height: 40, width: 'auto' }}
          />
          <Typography variant="h5" component="div" sx={{ flexGrow: 1, fontWeight: 600, display: { xs: 'none', sm: 'block' } }}>
            8qn-download
          </Typography>
        </Box>
        
        <Box sx={{ flexGrow: 1 }} />
        
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <IconButton 
            color="inherit"
            onClick={onBasketClick}
            sx={{ display: { lg: 'none' } }}
          >
            <Badge badgeContent={basketCount} color="primary">
              <ShoppingBasketIcon />
            </Badge>
          </IconButton>
          <Box sx={{ display: { xs: 'none', lg: 'block' } }}>
            <Badge badgeContent={basketCount} color="primary">
              <ShoppingBasketIcon />
            </Badge>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
